export const enum RoutePath {
  Home = "/",
  Experience = "/experience",
  PrivacyPolicy = "/privacy",
  Disclaimer = "/disclaimer",
  ComingSoon = "/coming-soon",
  
  // SM Pages
  Instagram = "/instagram",
  Linkedin = "/linkedin",
  Snapchat = "/snapchat",
  TikTok = "/tiktok",
  Youtube = "/youtube",
  X = "/x",

  // Dating Pages
  Hinge = "/hinge",
  CMB = "/cmb",
  Bumble = "/bumble",
  Tinder = "/tinder",

  // Wealth Pages
  Acorns = "/acorns",
  Ally = "/ally",
  Amex = "/amex",
  BankOfAmerica = "/bankofamerica",
  CapitalOne = "/capitalone",
  Chase = "/chase",
  Coinbase = "/coinbase",
  Discover = "/discover",
  Fidelity = "/fidelity",
  Robinhood = "/robinhood",
  Schwab = "/schwab",
  SoFi = "/sofi",
  Vanguard = "/vanguard",
  WellsFargo = "/wellsfargo",

  // Nature Pages
  AllTrails = "/AllTrails",
  GaiaGPS = "/Gais GPS",
  PeakVisor = "/PeakVisor",
  FarOut = "/FarOut",

  // EV Pages
  BMW = "/bmw",
  Ford = "/ford",
  Tesla = "/tesla",

  // Health Pages

  // Note taking

}
